

module.directive('deleteButton', function() {
    return {
        restrict: 'E',
        transclude: true,
        template: [
            "<action-button ng-if='deleting' delay='2000' result='_result(result)' action='doDelete()' done='finished()'>",
                "Confirm Delete",
            "</action-button>",
            "<button type='button' ng-click='start()'>",
                "<span class='text' ng-transclude></span>",
                "<span class='cancel'>Cancel</span>",
            "</button>",
        ].join(''),
        scope: {action: '&', done: '&', result: '&', deleting: '=?'},
        link: function(scope, element, attrs) {
            canClick = true;
            scope.deleting = false;

            function open() {
                scope.deleting = true;
                element.addClass('open')
            }

            function close() {
                scope.deleting = false;
                element.removeClass('open');
            }

            scope._result = function(result) {
                if (attrs.result) {
                    return scope.result({result: result});
                }
            }

            scope.start = function() {
                if (!canClick) return;
                if (scope.deleting) return close();
                open();
            };

            scope.doDelete = function() {
                canClick = false;
                element.addClass('deleting');
                return scope.action();
            }

            scope.finished = function() {
                close()
                scope.done();
                element.removeClass('deleting');
                canClick = true;
            }
        }
    };
});


module.directive('actionButton', function($q, $timeout) {
    return {
        restrict: 'E',
        transclude: true,
        template: [
            "<button ng-click='click()'>",
                "<span ng-transclude></span>",
            "</button>",
        ].join(''),
        scope: {
            action: '&',
            result: '&',
            done: '&',
            enabled: '=?',
        },
        link: function(scope, element, attrs) {
            var canClick = true, time,
                delay = parseInt(attrs.delay) || 0,
                successDelay = parseInt(attrs.successDelay) || 750,
                errorDelay = parseInt(attrs.errorDelay) || 750;

            if (attrs.enabled) {
                scope.$watch('enabled', function(enabled) {
                    element.toggleClass('disabled', !enabled);
                });
            } else {
                scope.enabled = true;
            }


            function getActionPromise() {
                var action = $q.when(scope.action && scope.action())
                if (delay > 0) {
                    return $q.all([$timeout(delay), action])
                        .then(function(r) { return r[1]; });
                }
                return action;
            }

            scope.click = function() {
                if (!canClick || !scope.enabled) return;
                canClick = false;
                element.addClass('acting')
                getActionPromise().then(success, error);
            };

            function success(actionResult) {
                if (attrs.result) {
                    scope.result({result: actionResult});
                }

                if (successDelay > 0) {
                    element.removeClass('icon-error');
                    element.addClass('done');
                    $timeout(successDelay).then(reset.bind(null, true, actionResult));
                } else {
                    reset(true, actionResult);
                }
            }

            function error(rejection) {
                if (scope.error) {
                    scope.error({error: rejection});
                }

                if (errorDelay > 0) {
                    element.addClass('error icon-error')
                    $timeout(errorDelay).then(reset.bind(null, false));
                } else {
                    reset();
                }
            }

            function reset(callDone, result) {
                element.removeClass('done error acting');
                canClick = true;
                if (callDone) scope.done({result: result});
            }
        },
    };
});


module.directive('formButtons', function() {
    return {
        restrict: 'E',
        templateUrl: 'util/forms/formButtons',
        scope: {
            expose: '=',
            deleteCallback: '&onDelete',
            cancelCallback: '&onCancel',
            submitCallback: '&onSubmit',
            closeCallback: '&onFinish',
            deleteEnabled: '=',
        },
        link: function(scope, element, attrs) {

            scope.cancelButtonText = attrs.cancelButtonText || "Cancel";
            scope.saveButtonText = attrs.saveButtonText || "Save";
            scope.deleteButtonText = attrs.deleteButtonText || "Remove";

            scope.buttons = angular.isDefined(attrs.onSubmit) ||
                angular.isDefined(attrs.onCancel);

            function setDelete(status) {
                element.toggleClass('deleting', status);
                scope.deleting = status;
            }

            scope.deleting = false;

            if (angular.isDefined(scope.deleteCallback)) {

                if (angular.isDefined(attrs.deleteEnabled)) {
                    scope.$watch('deleteEnabled', function(allow) {
                        scope.canDelete = allow;
                    });
                } else {
                    scope.canDelete = angular.isDefined(attrs.onDelete);
                }


                scope.doDelete = function(status) {
                    scope.deleteCallback();
                };

                scope.startDelete = angular.bind(this, setDelete, true);
                scope.endDelete = angular.bind(this, setDelete, false);
            }
        },
    };
});
